import auth from './auth.api';
import album from './album.api';


const api = {
    auth,
    album,
}

export default api;